import { assign } from 'lodash';
export const combineUserClaimsAndOrg = ([user, claims, organization]) => {
    if (!user.emailVerified) {
        return assign(user, { state: 'UnverifiedEmail' });
    }
    if (!claims || !organization) {
        return assign(user, { state: 'NoSubscription' });
    }
    if (!organization.subscriptionLive) {
        return assign(user, Object.assign({ state: 'LapsedSubscription' }, claims));
    }
    const state = { state: 'Authed' };
    return assign(user, Object.assign(Object.assign({}, state), claims));
};
